import CfPayments from './CfPayments'

export * from './typings'

export default CfPayments
